import CityPageTemplate from "../city-template/CityPageTemplate";
import { wilmingtonDeConfig } from "./data";

export default function WilmingtonDePage() {
  return <CityPageTemplate config={wilmingtonDeConfig} />;
}